
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon volume-slider-fill",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","viewBox":"0 0 1979.996 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.357 405.184L1921.07 36.465c22.094-4.343 42.655 12.57 42.655 35.087V440.27c0 19.748-16.01 35.758-35.758 35.758H52.254c-43.262 0-49.347-62.5-6.897-70.845z"}})])
          )
        }
      }
    